export default "__VITE_ASSET__0vIKLpsj__"